module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.info.red-2b5f584702e27526ba2662a788539033.svg";